var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmojiHappyFilled = function SvgEmojiHappyFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1M8 9a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1m-1 4a1 1 0 0 0-.848 1.53L7 14c-.848.53-.847.531-.847.531v.002l.004.004.007.012a3 3 0 0 0 .103.153 9.061 9.061 0 0 0 1.403 1.551C8.63 17.091 10.106 18 12 18s3.37-.91 4.33-1.747a9 9 0 0 0 1.403-1.551l.103-.153.008-.012.002-.004.002-.003A1 1 0 0 0 17 13zm10.848 1.53-.846-.529.74.463zM14 9a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H15a1 1 0 0 1-1-1"
  })));
};
export default SvgEmojiHappyFilled;